import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { appPath, isEmbeddedApp, isFocusedStudio } from './appNavigation';

export default function EmbeddedWorkspaceBridge() {
  const location = useLocation();

  useEffect(() => {
    if (!isEmbeddedApp()) return;
    window.parent.postMessage({
      type: 'instanttranscriber:workspace-ready',
      path: appPath(`${location.pathname}${location.search}`),
    }, window.location.origin);
    const close = (event) => {
      // Upload and result controls get first chance to consume Escape.
      if (isFocusedStudio() && event.key === 'Escape' && !event.defaultPrevented) {
        event.preventDefault();
        window.parent.postMessage({ type: 'instanttranscriber:workspace-close' }, window.location.origin);
      }
    };
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, [location.pathname, location.search]);

  return null;
}
